import React from "react";
import OneRowNavigation from "./OneRowNavigation";
import "./Styles/navigation.css"
import axios from "axios"

export default class Navigation extends React.Component {
    categories = []
    subCategories = []
    navRows = []
    categoriesIconsURL = process.env.REACT_APP_API_BASE_URL+'/images/categories/icons/';
 
    render(){
        this.categories = this.props.categories;
        this.subCategories = this.props.subCategories;

        if (this.categories.length > 0 && this.navRows.length == 0) {
            this.categories.map((x, i) => {
                this.navRows.push(<OneRowNavigation key={'navRow_'+x.slug+'_'+i} img={x.icon !== undefined ? this.categoriesIconsURL+x.icon : this.categoriesIconsURL+'default.svg'} label= {x.name} subs={this.subCategories.filter(s=>s.parent.id === x.id)} />)
            })   
        }

        return(
            <nav>
                <ul>
                    {this.navRows}
                </ul>
            </nav>
        )
    }
    
}